import { event } from "./event";

/**
 * tutorial_complete
 * このイベントは、ユーザーがオンボーディング プロセスを完了したことを示します。
 * チュートリアルを完了したユーザー数を把握するには、このイベントを目標到達プロセスで tutorial_begin とともに使用します。
 * このイベントのパラメータはありません。
 */
export const  tutorial_complete = () => event('tutorial_complete');